export const createIndexedDBStorage = () => {
    const dbName = 'axios-cache';
    const storeName = 'cache';


    const openDatabase = () => {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(dbName, 1);
            request.onupgradeneeded = (event) => {
                const db = event.target.result;
                if (!db.objectStoreNames.contains(storeName)) {
                    db.createObjectStore(storeName);
                }
            };

            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    };

    const withStore = async (mode, callback) => {
        const db = await openDatabase();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(storeName, mode);
            const store = transaction.objectStore(storeName);
            const request = callback(store);
            request.onsuccess = (event) => resolve(event.target.result);
            request.onerror = (event) => reject(event.target.error);
        });
    };




    return {
        async find(key) {
            return withStore('readonly', (store) => store.get(key));
        },
        async set(key, value) {
            await withStore('readwrite', (store) => store.put(value, key));
        },
        async remove(key) {
            await withStore('readwrite', (store) => store.delete(key));
        },
        async clear() {
            await withStore('readwrite', (store) => store.clear());
        },
    };
};



const DB_NAME = 'ReduxStoreDB';
const STORE_NAME = 'appState';
const DB_VERSION = 1;

function openDatabase() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = function (event) {
      resolve(event.target.result);
    };

    request.onerror = function (event) {
      reject(event.target.error);
    };
  });
}

export async function saveState(key, state) {
  const db = await openDatabase();
  const transaction = db.transaction([STORE_NAME], 'readwrite');
  const store = transaction.objectStore(STORE_NAME);
  store.put(state, key);
  return new Promise((resolve, reject) => {
    transaction.oncomplete = () => resolve();
    transaction.onerror = () => reject(transaction.error);
  });
}

export async function loadState(key) {
  const db = await openDatabase();
  const transaction = db.transaction([STORE_NAME], 'readonly');
  const store = transaction.objectStore(STORE_NAME);
  return new Promise((resolve, reject) => {
    const request = store.get(key);
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}
export async function clearState(key) {
  try {
    const db = await openDatabase(); 
    const tx = db.transaction([STORE_NAME], 'readwrite');
    await tx.objectStore('store').delete(key);
    await tx.done;
  } catch (err) {
    console.error('Error clearing state from IndexedDB', err);
  }
}